// src/components/SceneLayers/Nodes/Node/IconTypes/NonIsometricIcon.tsx

import { Box } from '@mui/material';
import { useState, useEffect } from 'react';
import { Icon } from 'src/types';
import { PROJECTED_TILE_SIZE } from 'src/config';
import { getIsoProjectionCss } from 'src/utils';
import { iconCacheManager } from '@/utils/IconCacheManager';

interface Props {
  icon: Icon;
}

export const NonIsometricIcon = ({ icon }: Props) => {
  const [cachedUrl, setCachedUrl] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadIcon = async () => {
      try {
        const url = await iconCacheManager.getIcon(icon.url);

        if (isMounted) {
          setCachedUrl(url);
        }
      } catch (error) {
        console.error('Failed to load icon:', icon.url, error);
        if (isMounted) {
          // Use original URL as fallback
          setCachedUrl(icon.url);
        }
      }
    };

    loadIcon();

    return () => {
      isMounted = false;
    };
  }, [icon.url]);

  if (!cachedUrl) {
    return null; // Don't render until cached URL is ready
  }

  return (
    <Box sx={{ pointerEvents: 'auto' }}>
      <Box
        sx={{
          position: 'absolute',
          // Use your centering values here (the ones you fixed with trial and error)
          left: -50,
          top: -PROJECTED_TILE_SIZE.height / 2,
          transformOrigin: 'top left',
          transform: getIsoProjectionCss()
        }}
      >
        <Box
          component="img"
          src={cachedUrl}
          alt={`icon-${icon.id}`}
          draggable={false}
          sx={{
            width: PROJECTED_TILE_SIZE.width * 0.7,
            WebkitUserDrag: 'none',
            userSelect: 'none'
          }}
        />
      </Box>
    </Box>
  );
};
